module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#youtube",
      toString: function () {
        return this.url;
      }
    }